"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LexusButton = void 0;
var _reactRouter = require("@tanstack/react-router");
var _react = _interopRequireWildcard(require("react"));
var _config = require("../../_nextgen/packages/config");
var _Overlay = require("../../modules/Overlay");
var _HtmlText = _interopRequireDefault(require("../../packages/HtmlText"));
var _getNodeText = require("../../utilities/getNodeText");
var _analytics = _interopRequireWildcard(require("../analytics"));
var _Link = require("../Link");
var _index = require("./index.enum");
var _index2 = _interopRequireDefault(require("./index.styled"));
var _jsxRuntime = require("react/jsx-runtime");
const DEFAULT_THEME = "PrimaryBlack";
const LexusButton = function (_ref) {
  let {
    href,
    text,
    children = "",
    theme = DEFAULT_THEME,
    variant,
    size = "",
    onClick,
    active = false,
    ariaLabel = "",
    additionalAnalytics = {},
    isExternal: isExternalProp = undefined,
    isexternal = undefined,
    disableRouter = false,
    ...rest
  } = _ref;
  const router = (0, _reactRouter.useRouter)();
  const isTanstackLink = href && router && (rest === null || rest === void 0 ? void 0 : rest.target) !== "_blank" && !disableRouter;
  const [show] = (0, _Overlay.useOverlay)({
    id: "third-party-interstitial"
  });
  const isOpinionatedExternalUrl = (0, _Link.checkIsOpinionatedUrl)(href);
  const {
    REACT_APP_USE_THIRD_PARTY_INTERSTITIAL = true
  } = (0, _config.useConfig)();
  const _isExternal = isExternalProp !== null && isExternalProp !== void 0 ? isExternalProp : isexternal;
  const isExternal = Boolean(typeof _isExternal === "undefined" ? undefined : JSON.parse(_isExternal));
  const isLink = typeof href !== "undefined";
  const renderedText = text || children;
  const DynamicTag = isLink ? _index2.default.A : _index2.default.Button;
  const [buttonNodeText, setButtonNodeText] = (0, _react.useState)("");
  (0, _react.useEffect)(function () {
    setButtonNodeText((0, _getNodeText.getNodeText)(renderedText));
  }, [renderedText]);
  const fireAnalytics = (0, _analytics.default)("LexusButton", {
    theme: variant !== null && variant !== void 0 ? variant : theme,
    size,
    text: buttonNodeText,
    active,
    ...additionalAnalytics
  });
  const handleOnClick = function (e) {
    const shouldTriggerInterstitial = (isExternal !== null && isExternal !== void 0 ? isExternal : isOpinionatedExternalUrl) && document.querySelector("#third-party-interstitial") !== null && REACT_APP_USE_THIRD_PARTY_INTERSTITIAL;
    fireAnalytics("click");
    if (shouldTriggerInterstitial) {
      e.preventDefault();
      show({
        href,
        target: rest === null || rest === void 0 ? void 0 : rest.target
      });
    }
    if (typeof onClick === "function") {
      onClick(e);
    }
  };

  /**
   * TODO:
   * - Separate Concerns
   * 	- Lexus Button should not be making Wrapper decisions based on theme.
   */
  const Wrapper = _index.GazooRacingThemeTuple.includes(theme) ? _index2.default.TextWrapper : _react.default.Fragment;
  return (
    /*#__PURE__*/
    // @ts-ignore: DynamicTag has no construct or call signatures
    (0, _jsxRuntime.jsx)(DynamicTag, {
      $variant: variant !== null && variant !== void 0 ? variant : theme,
      $buttonSize: size,
      href: href,
      $active: active,
      as: isTanstackLink ? _Link.VCRLink : undefined,
      ...rest,
      onClick: handleOnClick,
      "aria-label": ariaLabel || rest["aria-label"] || buttonNodeText,
      "data-testid": "LexusButton",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Wrapper, {
        children: typeof renderedText === "string" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_HtmlText.default, {
          children: renderedText
        }) : renderedText
      })
    })
  );
};
exports.LexusButton = LexusButton;
var _default = exports.default = (0, _analytics.withAnalytics)(LexusButton)({
  _component: "LexusButton"
});